import React from 'react';
import { Box } from '@mui/material';
import { COLORS } from 'components';

export const SectionLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Box
        sx={{
            fontSize: '12px',
            fontWeight: 700,
            color: COLORS.Mainblue,
            textTransform: 'uppercase',
            letterSpacing: '0.3px',
            mb: 1.5,
        }}
    >
        {children}
    </Box>
);
